export const clearLoginInfo = () => {
    localStorage.clear('doctoraU');
}